import { render, staticRenderFns } from "./highlightSection.vue?vue&type=template&id=6977a906&"
import script from "./highlightSection.vue?vue&type=script&lang=js&"
export * from "./highlightSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports